module.exports = __webpack_public_path__ + "static/media/om-statsforvalteren.fa81a2bc.png";